/* eslint-disable import/no-anonymous-default-export */
import { AutoComplete, DatePicker, Form, Input, notification, Select } from "antd";
import { useParams } from "react-router-dom";
import DataSave from "../common/components/DataSave";
import MainLayout from "../common/components/MainLayout";
import useEquiposRadarAPI, { Equipo, EquipoForm, ManoCirculacion, TipoCirculacion, TipoEquipo, UbicacionEjidoUrbano } from "./useEquiposAPI";

import "moment/locale/es-mx";
import locale from "antd/es/date-picker/locale/es_ES";
import moment from "moment";
import { useEffect, useState } from "react";
import { ActionResult } from "../common/hooks/useApi";
import useAgentesAPI, { Agente } from "../agentes/useAgentesAPI";
import useConfiguracionesProduccionAPI, { ConfiguracionProduccion } from "../configuraciones-produccion/useConfiguracionesProduccionAPI";
import TextArea from "antd/lib/input/TextArea";
import { AxiosError } from "axios";

moment.updateLocale("es-mx", {
  week: {
    dow: 1,
  },
});


export default () => {
  const { id } = useParams();
  const api = useEquiposRadarAPI();
  const configuracionesProduccionApi = useConfiguracionesProduccionAPI();
  const agentesApi = useAgentesAPI();
  const [configuracionesProduccionResponse, setConfiguracionesProduccionResponse] =
    useState<ActionResult<ConfiguracionProduccion[]>>();
  const [agentesResponse, setAgentesResponse] =
    useState<ActionResult<Agente[]>>();
  const [categoriasResponse, setCategoriasResponse] = useState<ActionResult<Equipo[]>>();
  const successRoute = "/equipos";

  const onAxiosError = (error: AxiosError) => {
    if (error.response?.data.value == "Equipo.EquipoExistente") {
      notification.error({
        placement: 'bottomRight',
        message: "Nombre de equipo existente en la unidad de producción"
      })
      return false;
    }
  };

  useEffect(() => {
    configuracionesProduccionApi.list({ $expand: ["UnidadProduccion"] }).then(setConfiguracionesProduccionResponse);    
    agentesApi.list({}).then(setAgentesResponse);
    api.listCategorias({}).then(setCategoriasResponse);
  }, []);

  return (
    <MainLayout title="Guardar equipo">
      <DataSave<Equipo, Equipo, EquipoForm>
        list={(query) =>
          api.list({ ...query, ...{ $expand: [] } })
        }
        onAxiosError={onAxiosError}
        save={api.save}
        transformOnLoad={async (value) => ({
          ...value,
          ...{
            FechaVerificacion: moment(value.FechaVerificacion),
            FechaVencimientoVerificacion: moment(
              value.FechaVencimientoVerificacion
            ),
          },
        })}
        transformOnSave={async (value) => ({
          ...value,
          ...{
            FechaVerificacion:
              value.FechaVerificacion ? value.FechaVerificacion.toISOString() : null,
            FechaVencimientoVerificacion:
              value.FechaVencimientoVerificacion ? value.FechaVencimientoVerificacion.toISOString() : null,
          },
        })}
        id={id}
        successRoute={successRoute}
      >
        <Form.Item
          rules={[{ required: true, message: "Campo requerido" }]}
          required
          name={"Nombre"}
          label="Nombre"
          help="Utilizado para identificar el equipo en la precarga"
        >
          <Input />
        </Form.Item>

        <Form.Item
          rules={[{ required: true, message: "Campo requerido" }]}
          required
          name={"Categoria"}
          label="Categoría"
          help="Ej: Radar, Alcoholímetro"
        >
          <AutoComplete options={categoriasResponse?.data?.value.map(c => ({ value: c.Categoria, text: c.Categoria }))} />
        </Form.Item>

        <Form.Item
          rules={[{ required: true, message: "Campo requerido" }]}
          required
          name={"ConfiguracionProduccionId"}
          label="Configuración de producción"
        >
          <Select loading={!configuracionesProduccionResponse}>
            {configuracionesProduccionResponse?.data?.value.map((u) => (
              <Select.Option key={u.Id} value={u.Id}>
                {u.Nombre} - {u.UnidadProduccion.Nombre}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>


        <Form.Item
          rules={[{ required: true, message: "Campo requerido" }]}
          required
          name={"Marca"}
          label="Marca"
        >
          <Input />
        </Form.Item>

        <Form.Item
          rules={[{ required: true, message: "Campo requerido" }]}
          required
          name={"Modelo"}
          label="Modelo"
        >
          <Input />
        </Form.Item>

        <Form.Item
          rules={[{ required: true, message: "Campo requerido" }]}
          required
          name={"NroSerie"}
          label="Nro. de serie"
        >
          <Input />
        </Form.Item>

        <Form.Item
          name={"Lugar"}
          label="Lugar"
        >
          <Input />
        </Form.Item>

        <Form.Item


          label={"DNCI"}
          name="CodigoDnci"
        >
          <Input />
        </Form.Item>

        <Form.Item


          label={"Primitiva"}
          name="CodigoPrimitiva"
        >
          <Input />
        </Form.Item>

        <Form.Item


          label={"Fecha de verificacion"}
          name="FechaVerificacion"
        >
          <DatePicker format={"DD/MM/YYYY"} locale={locale} />
        </Form.Item>

        <Form.Item


          label={"Fecha de vencimiento de verificacion"}
          name="FechaVencimientoVerificacion"
        >
          <DatePicker format={"DD/MM/YYYY"} locale={locale} />
        </Form.Item>

        <Form.Item
          rules={[{ required: true, message: "Campo requerido" }]}
          required
          name={"AgenteId"}
          label="Agente"
        >
          <Select loading={!agentesResponse} allowClear>
            {agentesResponse?.data?.value.map((u) => (
              <Select.Option key={u.Id} value={u.Id}>
                {u.Nombre} {u.Apellido}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>


        <Form.Item
          rules={[{ required: true, message: "Campo requerido" }]}
          required
          label={"Tipo de equipo"}
          name="Tipo"
        >
          <Select>
            <Select.Option value={"FIJO" as TipoEquipo}>Fijo</Select.Option>
            <Select.Option value={"MOVIL" as TipoEquipo}>Móvil</Select.Option>
            <Select.Option value={"OTRO" as TipoEquipo}>Otro</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item label={"Descripción"} name="Descripcion">
          <TextArea />
        </Form.Item>

        <Form.Item
                label={"URI de la transmisión"}
                name={"UriTransmision"}
            >
                <Input />
        </Form.Item>


        <Form.Item
                label={"Regex de fecha/hora para el nombre del video"}
                name={"RegexFechaHoraNombreVideo"}
                help={"Expresión regular para interpretar el nombre del video y tomar la fecha/hora. Debe contar con los grupos d,m,y,h,i,s"}
            >
                <Input />
        </Form.Item>

      </DataSave>
    </MainLayout>
  );
};
